import { Pipe, PipeTransform, inject } from '@angular/core';
import { ActivityInterface } from '@vendasta/crm';
import { CrmFieldService, StandardIds, SystemFieldIds } from '../shared-services/crm-services/field.service';

@Pipe({
  name: 'crmIsTaskOverdue',
  standalone: true,
})
export class CrmIsTaskOverduePipe implements PipeTransform {
  private readonly fieldService? = inject(CrmFieldService);

  transform(activity?: ActivityInterface): boolean {
    if (!activity || !this.fieldService) {
      return false;
    }
    const taskStatus = this.fieldService.getFieldValueFromCrmObject(
      activity,
      StandardIds.ActivityTaskStatus,
    )?.stringValue;
    if (taskStatus === 'Completed') {
      return false;
    }
    const effectiveDate = this.fieldService.getFieldValueFromCrmObject(
      activity,
      SystemFieldIds.ActivityEffectiveDate,
    )?.dateValue;
    if (!effectiveDate) {
      return false;
    }
    return effectiveDate.getTime() < Date.now();
  }
}
